export default __webpack_public_path__ + "./images/th.0e7d7cd9.png";